import { mapGetters } from 'vuex'
import Create from '../create'
import swal from 'sweetalert'
import Paginate from 'vuejs-paginate'

export default {
  name: 'list',
  components: {Create, Paginate},
  props: [],
  data () {
    return {
      per_page: 20,
      btn_submit: false,
      tag: {},
      errors: {}
    }
  },
  computed: {
    ...mapGetters({
      tags: 'Tag/getListTag',
      total: 'Tag/getTotal',
      last_page: 'Tag/getLastPage'
    })
  },
  mounted () {
    this.$loading.start()
    this.$store.dispatch('Tag/getListTag', {page: 1, per_page: this.per_page}).then(res => {
      this.$loading.complete()
    }).catch(errors => {
      this.$loading.fail()
    })
  },
  methods: {
    destroy (tag) {
      swal({
        title: this.$t('notify.delete_comfirm'),
        icon: 'warning',
        buttons: true,
        dangerMode: true
      })
        .then((willDelete) => {
          if (willDelete) {
            this.$loading.start()
            this.$store.dispatch('Tag/destroyTag', {
              tag: tag
            }).then((res) => {
              this.$notify({
                group: 'success',
                title: this.$t('notify.notify'),
                text: this.$t('notify.delete_success')
              })
              this.$loading.complete()
            }).catch(errors => {
              this.$loading.complete()
            })
          }
        })
    },
    showModalEdit (tag) {
      this.tag = {}
      this.$loading.start()
      this.$store.dispatch('Tag/showTag', {tag}).then(res => {
        this.tag = res
        this.$refs.updateForm.show()
        this.$loading.complete()
      }).catch(errors => {
        this.$loading.fail()
      })
    },
    update (tag) {
      this.$loading.start()
      this.$store.dispatch('Tag/updateTag', {tag: this.tag}).then(res => {
        this.$refs.updateForm.hide()
        this.$loading.complete()
      }).catch(errors => {
        if (errors.status === 422) {
          this.errors = errors.data.error
        }
        this.$loading.fail()
      })
    },
    changePerPage () {
      this.$loading.start()
      this.$store.dispatch('Tag/getListTag', {page: 1, per_page: this.per_page}).then(res => {
        this.$loading.complete()
      }).catch(errors => {
        this.$loading.fail()
      })
    },
    changePage (page) {
      this.$loading.start()
      this.$store.dispatch('Tag/getListTag', {page: page, per_page: this.per_page}).then(res => {
        this.$loading.complete()
      }).catch(errors => {
        this.$loading.fail()
      })
    },
    addChkItem (tag){
      this.$router.push({ path:'checklist-items', params: {tag: tag}})
      // this.$router.push('checklist-items')
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/tag/list/list.js